import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, Alert } from "@mui/material";
import { report  } from "../../features/reports/reportsSlice";
import { TitleWSelect, InfoTotal } from "../Tools";
import { getYears } from "../Tools/functions";

const initialState = { total: 0, events: [] };

const ReportTwo = () => {
    const { isLoading } = useSelector(state => state.progress);
    const [data, setData] = useState(initialState);
    const [status, setStatus] = useState('idle');
    const [year, setYear] = useState('');
    const options = useMemo(() => getYears(), [])
    const dispatch = useDispatch();
    const headers = ['Evento', 'Modalidad', 'Área', 'Tipo', 'Temática', 'Fecha', 'Estudiantes', 'Docentes', 'Administrativos', 'Externos', 'Total']
    
    const handleChange = (e) => {
        setYear(e.target.value)
        if(e.target.value !== ''){
            report(`two/year/${e.target.value}`, dispatch, setData, setStatus)
        }else{
            setStatus('idle')
            setData([]);
        }
    }

    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }} maxWidth='xl'>
            <TitleWSelect title={'REPORTE DE ASISTENCIA'} handleChange={handleChange} options={options} year={year} />
            { status === 'succeeded' && <InfoTotal num={data.total} /> }
            { isLoading ? <Skeleton animation='wave' height={200} /> : ( data.total ? (
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    { headers.map((h, i) => <TableCell key={i}>{h}</TableCell>) }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { data.events.map(({ evento, modalidad, area, tipo, tematica, fecha, estudiantes, docentes, adminsitrativos, externos, total }, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{evento}</TableCell>
                                        <TableCell>{modalidad}</TableCell>
                                        <TableCell>{area}</TableCell>
                                        <TableCell>{tipo}</TableCell>
                                        <TableCell>{tematica}</TableCell>
                                        <TableCell>{fecha}</TableCell>
                                        <TableCell align="center">{estudiantes}</TableCell>
                                        <TableCell align="center">{docentes}</TableCell>
                                        <TableCell align="center">{adminsitrativos}</TableCell>
                                        <TableCell align="center">{externos}</TableCell>
                                        <TableCell align="center"><b>{total}</b></TableCell>
                                    </TableRow>
                                )) }
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : status === 'succeeded' ? <Alert severity="warning">No se encontraron resultados</Alert>  : null
            )}
        </Container>
    )
}

export default ReportTwo;